module.exports = __webpack_public_path__ + "img/kelebihan-1.b22582d6.jpg";